"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Comment["default"];
  }
});

var _Comment = _interopRequireDefault(require("./Comment"));


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/commonjs/views/Comment/index.js
// module id = 7316
// module chunks = 0